module.exports = __webpack_public_path__ + "img/9788958283966.90272da6.jpg";